// @flow

import React from 'react'
import styled from 'styled-components'
import { MEDIUM } from '@streamr/streamr-layout/styled'
import logoHorizontalPositiveMonoLockup from './assets/logo_horizontal_positive_mono_lockup.svg'
import logoHorizontalColourLockup from './assets/logo_horizontal_colour_lockup.svg'
import logoHorizontalReversedMonoLockup from './assets/logo_horizontal_reversed_mono_lockup.svg'
import logoMarkVerticalPositiveMonoLockup from './assets/logo_vertical_positive_mono_lockup.svg'
import logoVerticalColourLockup from './assets/logo_vertical_colour_lockup.svg'
import logoVerticalReversedMonoLockup from './assets/logo_vertical_reversed_mono_lockup.svg'
import logoPositiveMonoMark from './assets/logo_positive_mono_mark.svg'
import logoColourMark from './assets/logo_colour_mark.svg'
import logoReversedMonoMark from './assets/logo_reversed_mono_mark.svg'
import useTranslation from '~utils/useTranslation'
import Link from '~shared/Link'

const assets = {
    'horizontal-positive-mono-lockup': logoHorizontalPositiveMonoLockup,
    'horizontal-colour-lockup': logoHorizontalColourLockup,
    'horizontal-reversed-mono-lockup': logoHorizontalReversedMonoLockup,
    'vertical-positive-mono-lockup': logoMarkVerticalPositiveMonoLockup,
    'vertical-colour-lockup': logoVerticalColourLockup,
    'vertical-reversed-mono-lockup': logoVerticalReversedMonoLockup,
    'positive-mono-mark': logoPositiveMonoMark,
    'colour-mark': logoColourMark,
    'reversed-mono-mark': logoReversedMonoMark,
}

const DownIcon = () => (
    <svg width="12" height="12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M6 3v6M6 9L3.75 6.75M6 9l2.25-2.25"
            stroke="#fff"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

const DownloadButton = styled(Link)`
    display: inline-block;
    position: relative;
    border-radius: 4px;
    font-weight: ${MEDIUM};
    font-size: 10px;
    height: 20px;
    line-height: 20px;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    padding: 1px 18px 0 8px;
    display: flex;
    flex-direction: row;
    align-items: center;
    transition: 300ms background-color ease-in-out, 180ms opacity ease-in-out;

    svg {
        position: absolute;
        top: 4px;
        right: 4px;
    }

    &,
    :visited {
        background-color: #A3A3A3;
        color: #FFFFFF;
    }

    :hover {
        color: #FFFFFF;
        background-color: #B7B7B7;
    }

    :active,
    :focus {
        color: #FFFFFF;
        background-color: #CDCDCD;
    }
`

type Props = {
    className?: string,
    id: 'horizontal-positive-mono-lockup'
        | 'horizontal-colour-lockup'
        | 'horizontal-reversed-mono-lockup'
        | 'vertical-positive-mono-lockup'
        | 'vertical-colour-lockup'
        | 'vertical-reversed-mono-lockup'
        | 'positive-mono-mark'
        | 'colour-mark'
        | 'reversed-mono-mark'
}

const UnstyledLogo = ({ className, id }: Props) => {
    const { t } = useTranslation()
    const caption = t(`design.logoAssets.logo.${id}`)

    return (
        <div className={className}>
            <img src={assets[id]} alt={caption} />
            <DownloadButton
                href={`/resources/logos/${id}.zip`}
                noDecoration
                noHover
            >
                <span>
                    Download
                </span>
                <DownIcon />
            </DownloadButton>
        </div>
    )
}

const Logo = styled(UnstyledLogo)`
    background-color: #EFEFEF;
    border-radius: 8px;

    img {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }

    ${DownloadButton} {
        position: absolute;
        right: 12px;
        bottom: 12px;
        opacity: 0;
    }

    :hover,
    :focus-within {
        ${DownloadButton} {
            opacity: 1;
        }
    }
}
`

export default Logo
